///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	translationsManagerActionCreators,
	toastSuccessActionCreators,
	languagesActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getListTranslations = function* ({ payload }) {
	const bodyMsg = payload.filters
	const queryParam = payload.queryParam
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_LIST_TRANSLATIONS(queryParam)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(translationsManagerActionCreators.getListTranslationsSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(translationsManagerActionCreators.getListTranslationsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setTranslation = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idLanguage = payload.id
	const apiCall = R.SET_TRANSLATION(idLanguage)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.data)

		yield put(translationsManagerActionCreators.setTranslationSuccess(payload.data, idLanguage))

		if (idLanguage === user.idUserLanguage.id) {
			yield put(languagesActionCreators.getTranslationByLanguages(idLanguage))
		}

		yield put(toastSuccessActionCreators.hydrateToast('toast__translationManagement__update_success'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(translationsManagerActionCreators.setTranslationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_LIST_TRANSLATIONS, getListTranslations)
	yield takeLatest(ActionsTypes.SET_TRANSLATION, setTranslation)
}

export default sagas
